import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  ViewService,
  Security,
  SecurityService,
  ConfigService,
  getSecuredResources,
  SecuredResource,
  Person,
} from "../../../common";

interface SecuredAction {
  id: string;
  accessName: string;
  selected: boolean;
}

const SpecialUsers = ["Everybody", "Owner"];

interface SecuredActionGroup {
  resourceName: string;
  securedActions: SecuredAction[];
}

@Component({
  templateUrl: "./security-editor-view.html",
  standalone: false,
})
export class SecurityEditorView implements OnInit, OnDestroy {
  subscriptions: any[];
  role: Security;
  avaibleResources: SecuredResource[];
  selectedResources: SecuredActionGroup[];
  newUserName: string;
  errorMsg: string;
  specialUsers: string[];

  constructor(
    private viewService: ViewService,
    private dataService: SecurityService,
    private configService: ConfigService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    viewService.setViewData({ pageTitle: "Editor" });
  }

  ngOnInit() {
    this.configService.get().subscribe((config) => {
      console.log(config);
      this.avaibleResources = getSecuredResources(config.securedActionOptions);
      this.updateAccessList();
    });

    this.subscriptions = [
      this.route.params.subscribe((params) => {
        let roleId = params["roleId"];
        if (roleId) {
          this.dataService.get(roleId).subscribe((role) => {
            this.role = role;
            this.viewService.setViewData({
              pageTitle: `Editing role ${role.name}`,
            });
            this.updateAccessList();
          });
        } else {
          this.role = new Security();
          setTimeout(() => {
            this.viewService.setViewData({ pageTitle: "Creating New Role" });
          });
          this.updateAccessList();
        }
      }),
    ];
  }

  ngOnDestroy() {
    this.subscriptions.forEach((x) => x.unsubscribe());
  }

  updateAccessList() {
    let allResources = this.avaibleResources,
      roleResources = this.role && this.role.securedResources,
      enrolledUsers = (this.role && this.role.subscriptions) || [];

    if (!allResources || !roleResources) return;

    this.specialUsers = SpecialUsers.filter(
      (specialUser) =>
        enrolledUsers
          .map(function (u) {
            return u.userId;
          })
          .indexOf(specialUser) === -1
    );

    this.selectedResources = this.avaibleResources.map((resource) => {
      let selectedActions = roleResources.find((x) => x.resourceName === resource.resourceName);
      return {
        resourceName: resource.resourceName,
        securedActions: resource.accessList.map((permission) => {
          return {
            id: `${resource.resourceName}.${permission}`,
            accessName: permission,
            selected: selectedActions && selectedActions.accessList.indexOf(permission) > -1,
          };
        }),
      };
    });
  }

  toggleSecuredAction(action: SecuredAction) {
    this.dataService
      .synchronize({
        id: this.role.id,
        command: action.selected ? "AddPermission" : "RemovePermission",
        actionArgument: action.id,
      })
      .subscribe();
  }

  updateRoleInfo() {
    if (!this.role.name) return;
    let values = [this.role.name];
    if (this.role.description) values.push(this.role.description);

    this.dataService
      .synchronize({
        id: this.role.id,
        command: "UpdateProperties",
        actionArgument: values.join(";"),
      })
      .subscribe((response) => {
        if (this.role.isNew) {
          console.log(response);
          this.role.id = response.id;
        }
      });
  }
  addSpecialUser(specialUser: string) {
    this.addUser({ userId: specialUser, displayName: specialUser } as Person);
  }

  addUser(user: Person) {
    if (!user) return;

    if (
      !window.confirm(
        "Are you sure you want to add '{0}' to this role?".replace("{0}", user.displayName)
      )
    )
      return;

    this.dataService
      .synchronize({
        id: this.role.id,
        command: "AddUser",
        actionArgument: user.userId,
      })
      .subscribe((response) => {
        let specialUserIndex = this.specialUsers.indexOf(user.userId);
        if (specialUserIndex > -1) {
          this.specialUsers.splice(specialUserIndex, 1);
        }
        this.role.subscriptions.push(user);
        this.newUserName = "";
      });
  }

  removeUser(user: Person) {
    if (
      !window.confirm(
        "Are you sure you want to remove '{0}' from this role?".replace("{0}", user.displayName)
      )
    )
      return;
    this.dataService
      .synchronize({
        id: this.role.id,
        command: "RemoveUser",
        actionArgument: user.userId,
      })
      .subscribe(() => {
        if (SpecialUsers.indexOf(user.userId) > -1) this.specialUsers.push(user.userId);

        let subscriptions = this.role.subscriptions;
        let index = subscriptions
          .map(function (u) {
            return u.userId;
          })
          .indexOf(user.userId);
        if (index > -1) {
          subscriptions.splice(index, 1);
        }
      });
  }

  closeEditor() {
    this.router.navigate(["../"], { relativeTo: this.route });
  }
}
